
export function server(path) {
    if(path.startsWith("/")) path = path.substring(1);
    return `${process.env.REACT_APP_API_URL}/${path}`;
}
export function graphQL() {
    return server("graphql");
}
export const urlQueryOptions = {
    page: {values: ["page"], integer: true, default: 1},
    order: {values: ["order"], integer: true, default: 1},
    search: {values: ["search"], array: true, default: ""},
}


